import {GetterTree} from 'vuex';
import {CustomerDetailsInterface, CustomerStateInterface} from '@/store/modules/customer/types';
import {RootState} from '@/store/types';

export const getters: GetterTree<CustomerStateInterface, RootState> = {

    /**
     * Gets the customer details for current authenticated user.
     */
    getCustomerDetails(state: CustomerStateInterface): CustomerDetailsInterface | undefined {
        return state.customerDetails;
    },
};
